import React from "react"
import { connect } from "react-redux"
import {values, keys} from "lodash"

import { push } from "connected-react-router"
import CoolPage from "../components/CoolPage"

import "./HotelMenuSection.less"
import menu from "./hotelMenuSection.js"

// #TODO la imagen sticky de arriba no funciona (no es sticky vaya)


class HotelMenuSection extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { selectedDish: "" }
  }

  render() {
    console.log("this is hotelmenusection.jsx")
    
    const filteredMenu = values(menu).filter(x => (x.tipo == this.props.menuType))
    
    console.log({
      menuType: this.props.menuType,
      filteredMenu
    })
    
    const selectedImg = this.state.selectedDish 
      ? menu[this.state.selectedDish || 0].mainImage 
      : filteredMenu[0].mainImage
    
    return (
      <CoolPage
        containerProps={{ className: "tepa menuPageSection" }}
        title={this.props.menuType /* #TODO chino! */}
        barColor={[255, 255, 255]}
        className="tepaPage"
        fixedBar
      >
        <div className="big" style={{ backgroundImage: `url(${selectedImg})` }} />

        <div className="lista" id="lista">
          {
            filteredMenu.map(({ key, titleEs, titleCh, price, roundImage }, _i, array) => (
              <div 
                className={`caja ${this.state.selectedDish == key ? 'selected' : ""}`} 
                key={key}
                id={key}
                onClick={() => {
                  this.setState({selectedDish: key})
                  document.getElementById('lista').scrollTop = document.getElementById(key).offsetTop - (document.getElementById(array[0].key).offsetTop * 1.55)
                }}
              >
                <img className="img" src={roundImage} />
                <div className="text">
                  <p className="textCh">{titleCh}</p>
                  <p className="textEs">{titleEs}</p>
                </div>
                <p className="price">{price}€</p>
              </div>
            ))
          }
        </div>
        
      </CoolPage>
    )
  }
}

const mapStateToProps = (_state, ownProps) => ({
  menuType: ownProps.match.params.section
})

const mapDispatchToProps = dispatch => {
  const goto = url => dispatch(push(url))
  return {
    goto,
    gotoRooms: () => goto(`/catalogo/teparooms`),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HotelMenuSection)



// WEBPACK FOOTER //
// ./src/app/catalogo/hotels/HotelMenuSection.jsx